window.addEventListener("DOMContentLoaded", function () {    
    if (isMobileDevice()) {
        const videoElements = document.querySelectorAll('.MJ__loadVideo');
        videoElements.forEach(function(element) {
            // Remove the class and data-video attribute to prevent video loading
            element.removeAttribute('data-video');
            element.classList.remove('MJ__loadVideo');
        });
    }
    else {
        console.log('abc');
    }
});
// Detect mobile device
function isMobileDevice() {
    return window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}


